import { StockList } from './StockList';
import { StockSummary } from './StockSummary';

// Definir tipo explícito para los datos de la tabla
interface StockUbicacion {
  codigo: string;
  tipo: string;
  tipoId?: string;
  stock: number;
  ubicacionId?: string;
}

interface StockResumen {
  disponible: number;
  reservado: number;
  entrante?: number;
}

interface StockProps {
  data: StockUbicacion[];
  onAddStock?: () => void;
  onEditStock?: (row: StockUbicacion) => void;
  stockResumen?: StockResumen;
  productId?: string | number;
  readOnly?: boolean;
  /** Stock listado por ubicación (título, tabla, añadir); solo aplica a tenant_3pl + API de locations */
  showLocationStock?: boolean;
}

export const Stock = ({
  data,
  onAddStock,
  onEditStock,
  stockResumen,
  productId,
  readOnly = false,
  showLocationStock = true,
}: StockProps) => {
  // --- lógica para mostrar/ocultar resumen ---
  const isEditMode = !!productId;
  const resumenTodoCero =
    stockResumen &&
    stockResumen.disponible === 0 &&
    stockResumen.reservado === 0 &&
    (typeof stockResumen.entrante !== 'number' || stockResumen.entrante === 0);
  const mostrarResumenStock = stockResumen && (!isEditMode || !resumenTodoCero);

  const stockData = data;

  return (
    <>
      {mostrarResumenStock && <StockSummary stockResumen={stockResumen} />}

      {showLocationStock && (
        <StockList
          data={stockData}
          onAddStock={readOnly ? undefined : onAddStock}
          onEditStock={readOnly ? undefined : onEditStock}
          readOnly={readOnly}
        />
      )}
    </>
  );
};
